import React from "react";

import { MenuItem } from "react-bootstrap";
import {
    BusinessAccount,
    BusinessAccountAction,
    MenuEntry
} from "../../../../datatypes/businessaccounts/BusinessAccount";
import _ from "lodash";

type ActionProps = {
    action: BusinessAccountAction;
};

export function ActionLink(props: ActionProps) {
    const entry: MenuEntry = MenuEntry.fromAction(props.action);
    return <AccountLink entry={entry} />;
}

type EntryProps = {
    entry: MenuEntry;
};

export function AccountLink(props: EntryProps) {
    const entry = props.entry;
    return (
        <MenuItem href={entry.url} key={entry.url}>
            {entry.text}
        </MenuItem>
    );
}

type EntriesProps = {
    account: BusinessAccount | undefined | null;
};

export function AccountLinks(props: EntriesProps) {
    const activeAccount = props.account;
    const entries: MenuEntry[] = _.get(activeAccount, ["menuEntries"], []);
    return (
        <React.Fragment>
            {_.map(entries, (entry: MenuEntry) => (
                <AccountLink entry={entry} key={entry.text} />
            ))}
            <MenuItem divider />
        </React.Fragment>
    );
}
